module.exports = __webpack_public_path__ + "img/logo.5fcbcf6f.png";